/* ★ POPUP "RUN DITAHAN" — RUPA SAHAJA, dikongsi semua semakan sebelum Run (2026-09-18).
 *
 * Dipakai oleh:
 *   · PopupRuangGambarAgent — tab My Agent: card tiada ruang gambar (2026-09-13)
 *   · PopupPromptKosongFlow — Run Flow: card tiada prompt (2026-09-18)
 * Satu komponen supaya setiap popup "tiada automation dijalankan" kekal SERUPA (arahan user
 * 2026-09-18: "guna gaya yg sama"). Ubah rupa di sini = semua popup itu berubah serentak.
 * Rupa ini diangkat BULAT-BULAT daripada PopupRuangGambarAgent asal (13 Sept) — markup sama.
 *
 * Dirender melalui portal ke <body> supaya tiada stacking context kad yang menindihnya
 * (pengajaran Toast.jsx 2026-08-23). Token v3.9 dengan nilai sandaran — rupa lama tiada token.
 * Semua teks datang daripada pemanggil (sudah melalui T); `T` di sini hanya untuk "(tanpa nama)".
 *
 * senarai: [{ id, nama, keterangan }] — satu baris setiap card yang menahan larian.
 */
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import LangkahBergaris from './LangkahBergaris';

// gayaLangkah (2026-09-24): true = "Cara betulkan" sebagai langkah bergaris (LangkahBergaris; `cara` boleh berisi
//   { teks, tag[] }). Lalai false = senarai bernombor lama — popup lain tidak berubah sehingga dihidupkan.
export default function PopupRunDitahan({ ikon, idTajuk, tajuk, sebab, senarai, caraTajuk, cara, nota, butang, onTutup, T, gayaLangkah = false }) {
    const ada = Array.isArray(senarai) && senarai.length > 0;

    // Escape menutup popup. Hook WAJIB sebelum pulangan awal (peraturan hooks React).
    useEffect(() => {
        if (!ada) return undefined;
        const kekunci = (e) => { if (e.key === 'Escape') onTutup?.(); };
        window.addEventListener('keydown', kekunci);
        return () => window.removeEventListener('keydown', kekunci);
    }, [ada, onTutup]);

    if (!ada || typeof document === 'undefined') return null;

    const langkah = Array.isArray(cara) ? cara : [];

    return createPortal(
        <div
            role="presentation"
            onClick={() => onTutup?.()}
            style={{ position: 'fixed', inset: 0, zIndex: 10050, background: 'rgba(0,0,0,.62)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby={idTajuk}
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: '100%', maxWidth: 460, maxHeight: 'calc(100vh - 32px)', display: 'flex', flexDirection: 'column',
                    background: 'var(--s-panel, #ffffff)', color: 'var(--s-ink, #262626)',
                    border: '1px solid var(--s-line, rgba(0,0,0,.08))', borderRadius: 'var(--s-r-lg, 16px)',
                    boxShadow: 'var(--s-shadow-modal, 0 24px 64px -20px rgba(0,0,0,.25))', overflow: 'hidden',
                }}
            >
                <div style={{ padding: '20px 22px 0', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    <span style={{ flex: 'none', width: 36, height: 36, borderRadius: 999, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'var(--s-warn-soft, rgba(217,119,6,.12))', color: 'var(--s-warn, #D97706)' }}>
                        <span className="material-symbols-outlined" style={{ fontSize: 20 }}>{ikon}</span>
                    </span>
                    <div style={{ minWidth: 0 }}>
                        <h3 id={idTajuk} style={{ margin: 0, fontSize: 16, fontWeight: 600, lineHeight: 1.35 }}>
                            {tajuk}
                        </h3>
                        <p style={{ margin: '6px 0 0', fontSize: 13, lineHeight: 1.55, color: 'var(--s-ink-2, #696969)' }}>
                            {sebab}
                        </p>
                    </div>
                </div>

                <div style={{ padding: '14px 22px 0', overflowY: 'auto', minHeight: 0 }}>
                    <div style={{ border: '1px solid var(--s-line, rgba(0,0,0,.08))', borderRadius: 10, overflow: 'hidden' }}>
                        {senarai.map((k, i) => (
                            <div key={k.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', borderTop: i === 0 ? 'none' : '1px solid var(--s-line, rgba(0,0,0,.08))' }}>
                                <span style={{ flex: 'none', width: 6, height: 6, borderRadius: 999, background: 'var(--s-warn, #D97706)' }} />
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <div title={k.nama} style={{ fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {k.nama || T('ws.common.noName', '(tanpa nama)')}
                                    </div>
                                    <div style={{ fontSize: 12, color: 'var(--s-ink-3, #8a8a8a)', marginTop: 1 }}>
                                        {k.keterangan}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div style={{ marginTop: 12, padding: '12px 14px', borderRadius: 10, background: 'var(--s-fill, rgba(0,0,0,.04))' }}>
                        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: gayaLangkah ? 12 : 6 }}>{caraTajuk}</div>
                        {gayaLangkah ? <LangkahBergaris langkah={langkah} /> : (
                        <ol style={{ margin: 0, paddingLeft: 18, fontSize: 13, lineHeight: 1.55, color: 'var(--s-ink-2, #696969)' }}>
                            {langkah.map((c, i) => <li key={i} style={{ marginTop: i === 0 ? 0 : 3 }}>{c}</li>)}
                        </ol>
                        )}
                    </div>
                </div>

                <div style={{ padding: '16px 22px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, color: 'var(--s-ink-3, #8a8a8a)' }}>{nota}</span>
                    <button
                        type="button"
                        autoFocus
                        onClick={() => onTutup?.()}
                        style={{ height: 36, padding: '0 18px', borderRadius: 10, border: '1px solid var(--s-primary, #262626)', background: 'var(--s-primary, #262626)', color: 'var(--s-primary-ink, #FAFAFA)', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
                    >
                        {butang}
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
}
